import { styled } from '@mui/material';
import { getZoomAdjustedPx } from 'components/ui/utilities/zoom';

interface ZoomStyleProps {
  zoomLevel: number;
}

const shouldForwardZoomProp = (prop: PropertyKey) => prop !== 'zoomLevel';

export const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}));

export const ContentArea = styled('main')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}));

export const PageContent = styled('div', {
  shouldForwardProp: shouldForwardZoomProp,
})<ZoomStyleProps>(({ theme, zoomLevel }) => ({
  backgroundColor: theme.palette.background.paper,
  boxSizing: 'border-box',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  padding: `0 ${getZoomAdjustedPx(16, zoomLevel)} ${getZoomAdjustedPx(16, zoomLevel)}`,
}));
